import React, { useState, useEffect } from 'react';
import { ButtonComponent, CustomDatePicker, Sessiontimeduration ,TimePickerModal } from 'tutorapp-components';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setSessionDate, setSessionDuration, setSessionStartTime, setSessionType } from '../redux/actions/sessionActions';
import formatDateTime from '../utils/dateTimeService';

export default function Sessiontimedurationscreen() {
  const moment = require('moment-timezone');

  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(''); // Changed to store start time as string
  const [sessionType, setSessiontype] = useState('');

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const sessions = useSelector((state) => state.session);
  const sessionDateTime = useSelector((state) => state.session.sessionDate);
  const duration = useSelector((state) => state.session.sessionDuration);
  const userPreferences = useSelector((state) => state.userPreferences);
  const sessionStartTime = useSelector((state) => state.session.sessionStartTime);

  // Convert time format to target timezone
  const convertTimeFormat = (timeString, targetTimezone) => {
    if (!timeString) return '';

    // Validate timeString format (HH:MM:SS)
    const match = timeString.match(/^(\d{2}:\d{2}:\d{2})$/);
    if (!match) return timeString;

    // Parse the time string as UTC and convert to target timezone
    const utcTime = moment.utc(timeString, 'HH:mm:ss');
    if (!moment.tz.zone(targetTimezone)) return timeString;

    const convertedTime = utcTime.tz(targetTimezone).format('HH:mm');
    return convertedTime;
  };

  // Duration options (15 min to 12 hours in 15-min increments)
  const durationOptions = Array.from({ length: 48 }, (_, i) => {
    const totalMinutes = (i + 1) * 15;
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    const label =
      hours > 0
        ? `${hours} hour${hours > 1 ? 's' : ''}${minutes > 0 ? ` ${minutes} min${minutes > 1 ? 's' : ''}` : ''}`
        : `${minutes} mins`;
    return { value: totalMinutes, label };
  });

  // Parse date string
  const parseDateString = (dateStr) => {
    if (!dateStr) return null;

    // Extract components from the fixed format "YYYY-MM-DD HH:MM:SS"
    const [datePart, timePart] = dateStr.split(' ');
    const [year, month, day] = datePart.split('-').map(Number);
    const [hour, minute, second] = timePart.split(':').map(Number);

    // Create a UTC date object (month is 0-based in JavaScript Date)
    return new Date(Date.UTC(year, month - 1, day, hour, minute, second));
  };

  useEffect(() => {
    if (sessionDateTime) {
      const parsedDate = parseDateString(sessionDateTime);
      setSelectedDate(parsedDate);
    }

    if (sessionStartTime) {
      setSelectedTime(sessionStartTime);
    }
  }, []);

  const handleTimeSelection = (time) => {
    setSelectedTime(time);
  };

  const handleContinue = () => {
    // Convert selectedTime from "08:00" to "08:00:00"
    let startTime;
    if (typeof selectedTime === 'string' && /^\d{2}:\d{2}$/.test(selectedTime)) {
      startTime = `${selectedTime}:00`;
    } else {
      throw new Error('Invalid time format. Expected "HH:mm"');
    }

    const userPreferencesTz = userPreferences?.timezone || 'UTC';
    // combine selected date and time into a single datetime string
    const combinedDateTimeStr = `${moment(selectedDate).format('YYYY-MM-DD')} ${startTime}`;
    const dateObj = moment.tz(combinedDateTimeStr, "YYYY-MM-DD HH:mm:ss", userPreferencesTz);

    // create a datetime object and set the timezone as is
    const nowInUserTz = moment.tz(userPreferencesTz);

    // compare the two datetime objects
    if (dateObj.isAfter(nowInUserTz)) {
      alert("You cannot submit a session for a future date.");
      return;
    }

    dispatch(setSessionDate(formatDateTime(selectedDate, startTime)));
    dispatch(setSessionStartTime(startTime));

    navigate('/session-report');
  };

  const handleSessionType = (type) => {
    setSessiontype(type);
    dispatch(setSessionType(type));
  };

  const handleback = () => {
    navigate('/sessiondetails');
  };


  return (
    <div>
      <Sessiontimeduration
        handlesessionback={handleback}
        icons={{
          sessionappointment: './images/ic_back.svg',
          close: './images/ic_close.svg',
          progress: './images/ic_one.svg',
        }}
      />

      <div className="d-flex justify-content-center align-items-center">
        <div className="d-flex flex-column align-items-center">
          {/* Custom Date Picker */}
          <div className="mb-2 mt-3" style={{ width: '325px' }}>
            <label
              className="d-block text-start mb-3"
              style={{ fontSize: 15, color: '#0b1422', fontFamily: 'GT-Walsheim-Medium' }}
            >
              Start Date
            </label>
            <CustomDatePicker
              selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
              userPreferences={userPreferences}
              dateicons={{ left: '/images/ic_calendar.svg', right: '/images/ic_down.svg' }}
            />
          </div>

          <div className="mb-2" style={{ width: '325px', fontFamily: 'GT-Walsheim' }}>
            <label
              className="d-block text-start mb-3"
              style={{ fontSize: 15, color: '#0b1422', fontFamily: 'GT-Walsheim-Medium' }}
            >
              Time
            </label>
            <TimePickerModal
              duration={duration}
              onTimeSelect={handleTimeSelection}
              defaultStartTime={convertTimeFormat(selectedTime , userPreferences?.timezone)}
              userPreferences={userPreferences}
             
            />
          </div>

          <div className="mb-2" style={{ width: '325px', fontFamily: 'GT-Walsheim' }}>
            <label
              className="d-block text-start mb-3"
              style={{ fontSize: 15, color: '#0b1422', fontFamily: 'GT-Walsheim-Medium' }}
            >
              Duration
            </label>
            <select
              value={duration}
              onChange={(e) => dispatch(setSessionDuration(Number(e.target.value)))}
              className="form-control text-center"
              style={{ height: '45px', fontFamily: 'GT-Walsheim', color: 'black' }}
            >
              <option value="" disabled>
                Select duration
              </option>
              {durationOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-3" style={{ width: '325px', fontFamily: 'GT-Walsheim' }}>
            <label
              className="d-block text-start mb-3"
              style={{ fontSize: 15, color: '#0b1422', fontFamily: 'GT-Walsheim-Medium' }}
            >
              Session Type
            </label>
            <div className="d-flex justify-content-between">
              <ButtonComponent
                onPress={() => handleSessionType('Online')}
                label="Online"
                style={{
                  backgroundColor: '#E9EDF1',
                  paddingVertical: 12,
                  width: '48%',
                  borderWidth: 1,
                  borderColor: sessions.sessionType === 'Online' ? 'red' : '#000',
                }}
                textStyle={{
                  color: '#000',
                  fontFamily: 'GT-Walsheim',
                }}
              />
              <ButtonComponent
                onPress={() => handleSessionType('In-Person')}
                label="InPerson"
                style={{
                  backgroundColor: '#E9EDF1',
                  paddingVertical: 12,
                  width: '48%',
                  borderWidth: 1,
                  borderColor: sessions.sessionType === 'In-Person' ? 'red' : '#000',
                }}
                textStyle={{
                  color: '#000',
                  fontFamily: 'GT-Walsheim',
                }}
              />
            </div>
          </div>

          {/* Continue Button */}
          <div style={{ width: '327px', marginTop: 10, fontFamily: 'GT-Walsheim' }}>
            <ButtonComponent
              onPress={handleContinue}
              label="Continue"
              style={{ backgroundColor: '#000', paddingVertical: 12, fontFamily: 'GT-Walsheim' }}
              textStyle={{ color: '#fff', fontFamily: 'GT-Walsheim' }}
            />
          </div>
          <div style={{ width: '327px', marginTop: 10, fontFamily: 'GT-Walsheim' }}>
            <ButtonComponent
              onPress={handleback}
              label="Back"
              style={{
                backgroundColor: '#E9EDF1',
                paddingVertical: 12,
                fontFamily: 'GT-Walsheim',
                borderWidth: 1,
                borderColor: '#000',
              }}
              textStyle={{ color: '#000', fontFamily: 'GT-Walsheim' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}